import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { getIPAddress } from 'actions/workflow';

export default function withIPAddress(WrappedComponent) {
  const HOC = (props) => {
    const dispatch = useDispatch();
    const [ipAddress, setIpAddress] = useState(null);

    useEffect(() => {
      dispatch(getIPAddress({
        data: {},
        success: (ipResponse) => {
          setIpAddress(ipResponse.ip);
        },
        fail: () => {
          console.log('Getting IP address failed');
        },
      }));
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
      dispatch(getIPAddress({
        data: {},
        success: (ipResponse) => {
          setIpAddress(ipResponse.ip);
        },
        fail: () => {
          console.log('Getting IP address failed');
        },
      }));
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.location]);

    return <WrappedComponent {...props} ipAddress={ipAddress || 'Not able to detect IP Address!'} />;
  };

  HOC.propTypes = {
    location: PropTypes.object,
  };

  HOC.defaultProps = {
    location: null,
  };

  return HOC;
}
